import { render } from "./InvDetail.vue?vue&type=template&id=00bc22ea&scoped=true"
import script from "./InvDetail.vue?vue&type=script&lang=js"
export * from "./InvDetail.vue?vue&type=script&lang=js"

import "./InvDetail.vue?vue&type=style&index=0&id=00bc22ea&lang=css"
import "./InvDetail.vue?vue&type=style&index=1&id=00bc22ea&scoped=true&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\HAVELI\\havelidashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00bc22ea"]])

export default __exports__